document.addEventListener("DOMContentLoaded", function () {

    const popup = document.getElementById("newsletter-popup");

    if (!popup) return;

    const closeBtn = popup.querySelector(".newsletter-popup__close");

    // Only show popup on the homepage
    if (window.location.pathname !== "/") {
        popup.style.display = "none";
        return;
    }

    // Don't show again during the same browsing session
    if (sessionStorage.getItem("newsletterPopupShown") === "true") {
        popup.style.display = "none";
        return;
    }

    // Show popup after 2 seconds
    setTimeout(function () {
        popup.style.display = "flex";

        // Remember that popup has been shown
        sessionStorage.setItem("newsletterPopupShown", "true");

    }, 2000);

    function closePopup() {
        popup.style.display = "none";
    }

    // Close button
    if (closeBtn) {
        closeBtn.addEventListener("click", closePopup);
    }

    // Close when clicking outside the popup
    popup.addEventListener("click", function (e) {
        if (e.target === popup || e.target.classList.contains("newsletter-popup__overlay")) {
            closePopup();
        }
    });

    // Close on ESC key
    document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") {
            closePopup();
        }
    });

});